import { Component, inject, input, output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import { PageMode } from "../../../constants/enums";
import { IntpAchievementModel, LoginResponse, TableActionEvent } from "../../../models";
import { LanguageService } from "../../../services";
import { ConfirmationModalComponent } from "../../general";
import { DataTableComponent } from "../../table/data-table/data-table";
import { IntpVisitAchievementsModalComponent } from "../intp-visit-achievements-modal/intp-visit-achievements-modal";

@Component({
  selector: "adaa-intp-visit-achievements-table",
  imports: [DataTableComponent],
  templateUrl: "./intp-visit-achievements-table.html",
  styleUrl: "./intp-visit-achievements-table.scss",
})
export class IntpVisitAchievementsTableComponent {
  private readonly _modalService = inject(NgbModal);
  private readonly _languageService = inject(LanguageService);

  achievements = input.required<IntpAchievementModel[]>();
  isDisabled = input<boolean>(false);
  valueChanged = output<IntpAchievementModel[]>();

  public get tableData() {
    return this.achievements().filter((e) => e.status !== this.Constants.OBJECT_STATUS.REMOVE);
  }

  Constants = Constants;

  public addNewClicked() {
    const currentUser = AdaaHelper.getLocalStorage(Constants.localStorageKeys.user, {
      type: "json",
    }) as LoginResponse;

    const achievement: IntpAchievementModel = {
      textAE: "",
      textEN: "",
      fakeId: Math.floor(Math.random() * 217 * 1000),
      status: Constants.OBJECT_STATUS.ACTIVE,
      userNameAE: currentUser.nameAE,
      userNameEN: currentUser.nameEN,
      createBy: currentUser.id,
    };

    this._openEditorModal(achievement, PageMode.create);
  }

  public actionClicked(event: TableActionEvent) {
    if (event.event === "view") this._openEditorModal(event.data, PageMode.view);
    else if (event.event === "edit") this._openEditorModal(event.data, PageMode.edit);
    else this._openDeleteModal(event.data);
  }

  private _openEditorModal(achievement: IntpAchievementModel, pageMode: PageMode) {
    const modal = this._modalService.open(IntpVisitAchievementsModalComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.pageMode.set(pageMode);
    modal.componentInstance.achievement.set(achievement);

    modal.result.then((e) => {
      if (!e) return;
      if (pageMode === PageMode.create) {
        this.achievements().push(e);
      } else {
        const index = this.achievements().findIndex((achievement) =>
          e.fakeId ? e.fakeId === achievement.fakeId : e.id === achievement.id
        );
        if (index > -1) this.achievements().splice(index, 1, e);
      }

      this.valueChanged.emit(this.achievements());
    });
  }

  private _openDeleteModal(achievement: IntpAchievementModel) {
    const modal = this._modalService.open(ConfirmationModalComponent, {
      centered: true,
      size: "md",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.header = "international_projects.visits.delete_achievement_title";
    modal.componentInstance.title = "international_projects.visits.delete_achievement_msg";

    modal.result.then((e) => {
      if (e) this._deleteConfirmed(achievement);
    });
  }

  private _deleteConfirmed(achievement: IntpAchievementModel) {
    const achievements = [...this.achievements()];
    if (achievement.fakeId) {
      this.valueChanged.emit(achievements.filter((e) => e.fakeId !== achievement.fakeId));
    } else {
      const attachment = achievements.find((e) => e.id === achievement.id);
      if (attachment) attachment.status = Constants.OBJECT_STATUS.REMOVE;
      this.valueChanged.emit(achievements);
    }
  }
}
